<template>
    <v-list>
        <v-list-item v-for="groupType in groupEventTypes" :key="groupType">
            <SoliBtn
                block
                @click="$emit('input', groupType)"
                :text="groupType"
                color="soli-grey"
                outlined
                class="mb-3"
                :loading="loading && groupType == value"
            >
            </SoliBtn>
        </v-list-item>
    </v-list>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: "",
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            apiLoading: false,
            groupEventTypes: ["Group Class", "Lab", "Band", "Summer Camp"],
        };
    },
    methods: {},
};
</script>
